<template>
  <div>
    <base-card>
      <v-card-text>
        <div class="d-flex flex-column align-center justify-center text-center py-6">
          <h3 class="mb-1">Procesamiento ATS</h3>
        </div>

        <v-row justify="center" class="mb-4">
          <v-col cols="12" sm="8" >
            <p class="text-subtitle-1 mb-0">
              Este módulo permite generar el <strong>Anexo Transaccional Simplificado (ATS)</strong> para el SRI.
              Seleccione el método de procesamiento: cargando un archivo XML o conectándose directamente al servicio de Bridge WS (aplica para clientes que cuenten con el servicio).
            </p>
          </v-col>
        </v-row>

        <v-row justify="center" class="mb-4">
          <v-col cols="12" sm="8">
            <v-tabs
              v-model="activeTab"
              grow
              background-color="transparent"
              color="blue darken-2"
            >
              <v-tab key="archivo">
                <v-icon left>mdi-file-xml-box</v-icon>
                Por Archivo XML
              </v-tab>
              <v-tab key="bridge">
                <v-icon left>mdi-web</v-icon>
                Por Bridge WS
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>

        <v-row justify="center" class="mb-4">
          <v-col cols="12" sm="8">
            <v-alert
              v-if="activeTab === 0"
              color="blue-grey"
              text
              dense
            >
              <v-icon left small>mdi-information-outline</v-icon>
              Seleccione el período a reportar, cargue el archivo XML generado en HiOffice y presione <strong>Procesar</strong>. Una vez completado, podrá descargar el archivo ATS generado.
            </v-alert>
            <v-alert
              v-if="activeTab === 1"
              color="blue-grey"
              text
              dense
            >
              <v-icon left small>mdi-information-outline</v-icon>
              Ingrese las credenciales de Bridge WS (en caso de que el sistema no las cargue automáticamente), valide la conexión con el <strong>Test de Conexión</strong>, seleccione el período y presione <strong>Generar ATS</strong>. La exportación se procesa en segundo plano; podrá hacer seguimiento del estado y descargar el archivo desde el <strong>listado de exportaciones</strong> que aparece debajo.
            </v-alert>
          </v-col>
        </v-row>

        <div v-if="activeTab === 0">
          <ats-file-processing ref="AtsFileProcessing" />
        </div>

        <div v-if="activeTab === 1">
          <ats-web-service-processing ref="AtsWebServiceProcessing" />
        </div>
      </v-card-text>
    </base-card>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeTab: 0,
      }
    },
    components: {
      AtsFileProcessing: () => import('./components/AtsFileProcessing'),
      AtsWebServiceProcessing: () => import('./components/AtsWebServiceProcessing'),
    },
  }
</script>
